import { Card, CardContent } from "@/components/ui/card";
import { ArrowUpCircle, ArrowDownCircle, RotateCcw, ShoppingCart } from "lucide-react";

export function MovementsTab({ movements }) {
  if (movements.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <ShoppingCart className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Sin movimientos registrados</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid gap-2">
      {movements.map(m => (
        <Card key={m.id} data-testid={`movement-${m.id}`}>
          <CardContent className="flex items-center justify-between p-3">
            <div className="flex items-center gap-3">
              {m.type === "entry" && <ArrowUpCircle className="w-5 h-5 text-emerald-500" />}
              {m.type === "waste" && <ArrowDownCircle className="w-5 h-5 text-red-500" />}
              {m.type === "order_deduction" && <RotateCcw className="w-5 h-5 text-blue-500" />}
              <div>
                <p className="font-medium text-sm">{m.stock_name}</p>
                <p className="text-xs text-muted-foreground">
                  {m.type === "entry" ? "Compra" : m.type === "waste" ? "Desperdicio" : "Pedido"} | {m.user_name}
                  {m.supplier && ` | ${m.supplier}`}
                  {m.order_number && ` | #${m.order_number}`}
                  {m.reason && ` | ${m.reason}`}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className={`font-bold ${m.quantity > 0 ? "text-emerald-500" : "text-red-500"}`}>
                {m.quantity > 0 ? "+" : ""}{m.quantity}
              </p>
              <p className="text-xs text-muted-foreground">
                {new Date(m.created_at).toLocaleString("es", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
              </p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
